export default __webpack_public_path__ + "static/bostjan-cigan-2a36c666a75c0d6b47bbedf136ade660.png";